import OriginalAlert from './Alert.svelte';
import Icon from '../icon/Icon.svelte';
import Title from './Title.svelte';
import Description from './Description.svelte';
import Extra from './Extra.svelte';
const Alert = OriginalAlert;
Alert.Title = Title;
Alert.Description = Description;
Alert.Leading = Icon;
Alert.Extra = Extra;
export default Alert;
